import { createContext } from 'react';

import type { Session } from '#src/shared/session';

/** @knip-ignore */
export type PrefetchedData = Readonly<Record<string, unknown>> | undefined;
export type PrefetchedUserData = Readonly<Record<string, unknown>> | undefined;

export type PrefetchContextData = Readonly<Record<string, PrefetchedData>> | undefined;
export type PrefetchUserContextData = Readonly<Record<string, PrefetchedUserData>> | undefined;
export type PrefetchSessionContextData = Session | undefined;

export const PrefetchContext = createContext<PrefetchContextData>(undefined);
export const PrefetchUserContext = createContext<PrefetchUserContextData>(undefined);
export const PrefetchSessionContext = createContext<PrefetchSessionContextData>(undefined);
